export default "__VITE_ASSET__0d03d1cb__"